import React, { useMemo } from "react";
import { Card, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { totalLineStringMeters } from "../../../../../map/utils/map-utils";
import { observer } from "mobx-react";
import { useStores } from "../../../../../shared/stores/RootStore";
import { formatDistanceByUnit } from "../../../../../shared/utils/format-utils";
import { DistanceUnit } from "@keita/lanepatrol-sdk";

const i18Prefix = "home:route.stats";

const CraWayStatsBase: React.FC = () => {
  const { routeDesignStore, craWayStore, surveyStore } = useStores();
  const craWay = craWayStore.getSelected()!;
  const { stats } = craWay;
  const distanceUnit = surveyStore.distanceUnit;

  const plannedDistance = useMemo(() => {
    if (!routeDesignStore.newPlannedTrajectory && craWay.plannedDistance) {
      return craWay.plannedDistance;
    }
    const plannedTrajectory =
      routeDesignStore.newPlannedTrajectory || craWay.plannedTrajectory;

    return plannedTrajectory ? totalLineStringMeters(plannedTrajectory) : 0;
    // eslint-disable-next-line
  }, [craWay.plannedDistance, routeDesignStore.newPlannedTrajectory]);

  return (
    <Card.Root p={2} fontSize="xs">
      <Text>
        {t(`${i18Prefix}.plannedDistance`, {
          value: formatDistanceByUnit(plannedDistance, distanceUnit),
          unit: distanceUnit === DistanceUnit.Imperial ? "mi" : "km",
        })}
      </Text>
      <Text>
        {t(`${i18Prefix}.totalDistance`, {
          value: formatDistanceByUnit(stats!.totalDistance, distanceUnit),
          unit: distanceUnit === DistanceUnit.Imperial ? "mi" : "km",
        })}
      </Text>
      <Text>
        {t(`${i18Prefix}.nNodes`)}
        {`: ${stats!.nNodes}`}
      </Text>
      <Text>
        {t(`${i18Prefix}.nNodesCoded`)}
        {`: ${stats!.nNodesCoded}`}
      </Text>
    </Card.Root>
  );
};

export const CraWayStats = observer(CraWayStatsBase);
